import Link from "ds/components/Link";

import { CellComponentProps } from "../types";
import useUserRolesListAnalytics from "../useUserRolesListAnalytics";

type UserRolesListItemGrantedAtCellProps = CellComponentProps;

const UserRolesListItemGrantedAtCell = ({ roleBinding }: UserRolesListItemGrantedAtCellProps) => {
  const trackAnalytics = useUserRolesListAnalytics();

  return (
    <Link
      size="small"
      href={`/spaces/${roleBinding.space.id}`}
      onPress={() => trackAnalytics("Space link clicked")}
    >
      {roleBinding.space.name}
    </Link>
  );
};

export default UserRolesListItemGrantedAtCell;
